<script>
    export let title = '';
</script>

<h2 class="title">{title}</h2>

<style>
    .title {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 20px;
        margin-top: 50px;
        position: relative;
    }
    .title::after {
        display: block;
        content:'';
        background: var(--color-primary);
        width: 38px;
        height: 3px;
        margin-top: 10px;

    }
</style>